import React from 'react';
import tw, { styled } from 'twin.macro';

import { inputStyles } from './TextInput';

const TextArea = styled(
  (
    {
      rows = 10,
      cols = 50,
      ...props
    }
  ) => <textarea rows={rows} cols={cols} {...props} />
)`
  ${tw`w-full block resize-none`}
  ${inputStyles}
  box-sizing: border-box;
`;

export default TextArea;
